module.exports = __webpack_public_path__ + "static/media/ic_form_active.f4ee222d.svg";